module.exports = __webpack_public_path__ + "static/media/onDemand.ced79516.svg";